<template>
  <div id="outlook" class="mb-5">
    <ReportHeader
      :reportTypeId="reportTypeId"
      :title="title"
      :subtitle="subtitle"
    />
    <div class="row mt-3 pb-5">
      <div class="col">
        <div class="table-responsive">
          <table class="table striped" id="outlookTable">
            <thead>
              <tr>
                <template v-if="outlookTable.Rows.length > 0">
                  <th class="tableHeader text-left" style="border-bottom: none">
                    {{ outlookTable.Rows[0].MonthYear }}
                  </th>
                  <th class="tableHeader" style="border-bottom: none">
                    {{ outlookTable.Rows[0].TwelveMM }}
                  </th>
                  <th class="tableHeader" style="border-bottom: none">
                    {{ outlookTable.Rows[0].TwelveTwelve }}
                  </th>
                  <th class="tableHeader" style="border-bottom: none">
                    {{ outlookTable.Rows[0].Phase }}
                  </th>
                </template>
              </tr>
            </thead>
            <tbody>
              <tr
                class="tableDataRow"
                v-for="(row, index) in outlookTable.Rows.slice(1)"
                v-bind:key="index"
              >
                <td class="rowTitle">{{ row.MonthYear }}</td>
                <td class="text-center">{{ row.TwelveMM }}</td>
                <td class="text-center">{{ row.TwelveTwelve }}</td>
                <td
                  v-if="row.Phase === 'A'"
                  style="color: #0a42d3"
                  class="tablePhases text-center"
                >
                  {{ row.Phase }}
                </td>
                <td
                  v-else-if="row.Phase === 'B'"
                  style="color: #44ac4e"
                  class="tablePhases text-center"
                >
                  {{ row.Phase }}
                </td>
                <td
                  v-else-if="row.Phase === 'C'"
                  style="color: #ff9916"
                  class="tablePhases text-center"
                >
                  {{ row.Phase }}
                </td>
                <td
                  v-else-if="row.Phase === 'D'"
                  style="color: #d2232a"
                  class="tablePhases text-center"
                >
                  {{ row.Phase }}
                </td>
                <td
                  v-else
                  style="color: #a7a9ab"
                  class="tablePhases text-center"
                >
                  {{ row.Phase }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-x-large-4 pb-3">
        <label style="background: #87cff3" class="outlookLabels">
          Expected Impact of Economic Trends
        </label>
        <ul
          class="boxHeight"
          style="
            background: rgb(249, 249, 249);
            padding: 1em;
            border-radius: 0px 0px 10px 10px;
          "
        >
          <li
            class="list1"
            v-for="(row, index) in outlookData.ExpectedImpact"
            v-bind:key="index"
          >
            {{ row }}
          </li>
        </ul>
      </div>
      <div class="col-x-large-4 pb-3">
        <label style="background: #5ab5a2" class="outlookLabels">
          Forecast
        </label>
        <ul
          class="boxHeight"
          style="
            background: rgb(249, 249, 249);
            padding: 1em;
            border-radius: 0px 0px 10px 10px;
          "
        >
          <li
            class="list2"
            v-for="(row, index) in outlookData.ForecastDescription"
            v-bind:key="index"
          >
            {{ row }}
          </li>
        </ul>
      </div>
      <div class="col-x-large-4 pb-3">
        <label style="background: #183961" class="outlookLabels">
          Management Objectives&trade;
        </label>
        <ul
          class="boxHeight"
          style="
            background: rgb(249, 249, 249);
            padding: 1em;
            border-radius: 0px 0px 10px 10px;
          "
        >
          <li
            class="list3"
            v-for="(row, index) in outlookData.ManagementObjectives"
            v-bind:key="index"
          >
            {{ row }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  import ReportHeader from '~/components/report/ReportHeader.vue';
  export default {
    name: 'OutlookComponent',
    components: {
      ReportHeader,
    },
    props: {
      companyName: String,
      outlookTable: Object,
      outlookData: Object,
      reportID: {
        type: Number,
        required: false,
        default: 0,
      },
      reportTypeId: {
        type: [String, Number],
        // required: true,
      },
    },
    computed: {
      title() {
        return `Outlook for ${this.companyName}`;
      },
      subtitle() {
        return this.outlookData.TableName;
      },
    },
  };
</script>
<style>
  #outlookTable tr td:first-child {
    border-left: 1px solid #dee2e6;
  }
  #outlookTable tr td:last-child {
    border-right: 1px solid #dee2e6;
  }
  .outlookHeaders {
    background: #3075a4;
    color: white;
    text-align: center;
    border: 0px !important;
  }
  .outlookLabels {
    color: white;
    padding: 1em;
    margin-bottom: 0px;
    border-radius: 10px 10px 0px 0px;
  }
  .topLeft {
    border-radius: 5px 0px 0px 0px;
    color: white;
  }
  .topRight {
    border-radius: 0px 5px 0px 0px;
    color: white;
  }
  .list1::before {
    color: #87cff3 !important;
  }
  .list2::before {
    color: #5ab5a2 !important;
  }
  .list3::before {
    color: #183961 !important;
  }
  .rowTitle {
    font-weight: bold;
  }
  .tableHeader {
    background: #3075a4;
  }
  table.dataTable.no-footer {
    border-bottom: none;
  }
</style>
